import axios from "lib/axios";
import { getOTPTokenCookie,setOTPTokenCookie } from "lib/Storage";

const requestOTP = async (phoneNumber) => {
  const { data } = await axios.post("/requestOtp", { phoneNumber });
  if(data.status === "OK"){
    setOTPTokenCookie(data.otpToken)
  }
  return data;
};

const submitOTP = async (code) =>{
  let otpToken = getOTPTokenCookie()
  const {data}  = await axios.post("/submitOtp",{otp:code,otpToken})
  return data;
}

const login = async (username, password) => {
  const { data } = await axios.post("/signin", username, password);
  return data;
};

const signup = async (username, password, referralCode) => {
  const { data } = await axios.post("/signup", {
    username,
    password,
    referralCode,
  });
  return data;
};

const logout = () => {
  // removeAuthCookie();
  // removeUserInStorage();
  // eslint-disable-next-line no-restricted-globals
  location.reload();
};

export { requestOTP, submitOTP, login, logout, signup };
